import { useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useIsAuthenticated, useSignOut } from "react-auth-kit";
import { authName } from "../App";

/**
 * react-auth-kit's RequireAuth calls signOut() while rendering.
 * That dispatch always allocates a new auth state, so once the session
 * is cleared the protected route re-renders, dispatches again, and React
 * hits "Maximum update depth exceeded" and wipes #root. The address bar
 * is already /login, which is the blank login page after logout.
 */
export default function RequireAuth({ children, loginPath = "/login" }) {
  const isAuthenticated = useIsAuthenticated();
  const signOut = useSignOut();
  const location = useLocation();
  const authed = isAuthenticated();

  useEffect(() => {
    if (authed) return;
    if (localStorage.getItem(authName)) signOut();
  }, [authed, signOut]);

  if (!authed) {
    return <Navigate to={loginPath} state={{ from: location }} replace />;
  }

  return children;
}
